import React from "react";
import { Link } from "react-router-dom";
import { CommunityProps } from "../../types";
import { hyundai } from "../../assets/images";
import { MdVerified } from "react-icons/md";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";

type EcoBookCardProps = {
  community: CommunityProps;
};

const EcoBookCard: React.FC<EcoBookCardProps> = ({ community }) => {
  const totalMembers = community?.members?.length;
  return (
    <Link to={`/ecobook/community/${community.name}/${community.id}`}>
      <div
        className="bg-white rounded h-[199px] lg:h-[258px] shadow-none lg:shadow font-Poppins lg:font-NotoSans"
        key={community.id}
      >
        <img
          src={
            community.communityHeaderImgUrl &&
            community.communityHeaderImgUrl !== "Url"
              ? ipfsGatewayImage(community.communityHeaderImgUrl)
              : hyundai
          }
          alt=""
          className="w-full object-cover h-[79px] lg:h-[105px]"
        />
        <div className="flex flex-col justify-between pr-1 pt-1 lg:pt-5 pl-[10.4px] h-[118px] lg:h-[147px]">
          <div className="w-full">
            <div className="flex gap-1 items-center">
              <MdVerified className="fill-lightGreen" />
              <h1 className="text-midGreen font-semibold text-[10px] lg:text-[11px]">
                {community?.name} Community
              </h1>
            </div>
            <div className="text-[#000] font-normal text-[8px] details2 lg:text-[10.37px]">
              <p>
                {community?.description} {/*community.description.length*/}{" "}
              </p>
            </div>
          </div>

          <div className="flex gap-3 items-end">
            {/* <div className="flex items-center gap-1">
              <div className="bg-green-600 w-[6px] h-[6px] rounded-full"></div>
              <div className=" text-[#000] text-[9px] font-normal">
                {community?.members?.length <= 1
                  ? community?.members?.length
                  : community?.members?.length}{" "}
                online
              </div>
            </div> */}
            <div className="flex items-center gap-1">
              <div className="bg-[#C4C9CE] w-[6px] h-[6px] rounded-full"></div>
              <div className=" text-[#000] text-[9px] font-normal">
                {`${totalMembers} member${totalMembers > 1 ? "s" : ""}`}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default EcoBookCard;
